import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col } from "antd";
import { paymentTypes } from "./constant";
import SectionHeader from "../../molecules/SectionHeader";
import OnlinePayment from "./onlinePayments";
import CourierPayment from "./courierPaymentReport";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrganizations
} from "../Organizations/ducks/actions";
import { getAllMerchantsService, getOrginationListService } from "./service";
import ExportAuditReportComponent from "../../modules/Reports/ExportAuditReportComponent";

export default (props: any) => {
  const dispatch: any = useDispatch();
  const [searchingText, setSearchText] = useState(null);
  const [searchingBy, setSearchBy] = useState(null);
  const [search, setSearch] = useState("");
  const [paymentType, setPaymentType] = useState(null);
  const [organizationList, setOrginizationList] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [orgId, setOrgId] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exportReport, setExportReport] = useState(false);
  const { type } = useParams();
  const [mid,setMid] = useState([]);
  const [midId,setSelectMid] = useState(null);
  const [isLoading, setIsloading] = useState(false);

  const organization = useSelector(
    (state: any) => state?.organization?.getOrganizations
  );
  
  let merchantIds = [];
  let initialSearchKeys = [];

  initialSearchKeys = 
  type === "Pickup-Requests" ? [
    { value: "orderId", label: "Order ID" },
    // { value: "bankRef", label: "Bank Ref" },
    { value: "propertyName", label: "Property Name" },
    { value: "unitCode", label: "Unit Code" }, //changed from community ref: 8405
  ] : type === "Login-Activity" ? [
    { value: "userName", label: "User Name" },
    { value: "portal", label: "Portal" }
  ] : [
    { value: "orderId", label: "Order ID" },
    { value: "bankRef", label: "Bank Ref" },
    { value: "propertyName", label: "Property Name" },
    { value: "unitCode", label: "Unit Code" }, //changed from community ref: 8405
  ];
 
  const orgList = async () => {

    try {
      const data = await getOrginationListService();
      data.push({
        orgId:null,
        name:"All Orgnizations"
       });
       data.reverse();
      setOrginizationList(data);
    } catch (errr) {
      console.log(errr)
    }
  }
 
  
  const getAllMerchants = async ()=>{

    try {
     
      let data = await getAllMerchantsService();
      
      data.push({
        merchant_id:null,
        businessUnitName:"All"
       });
       if(data?.length > 1){
        
      let uniqueArray =   data?.filter((item, index, self) =>
          index === self.findIndex(obj => obj?.merchant_id === item?.merchant_id)
        );
        uniqueArray?.forEach((item: { merchant_id: string; businessUnitName: any; })=>{
        merchantIds?.push({
          value:item?.merchant_id,
          label: !item?.merchant_id  ? `${item?.businessUnitName}` : `${item?.businessUnitName}  (${item?.merchant_id})`
        })
      })
     
    
      merchantIds.reverse();
      setMid(merchantIds);
       }
    } catch (errr) {
      console.log(errr)
    }
  }
  
  useEffect(() => {
    orgList();
    getAllMerchants();
  }, []);

  const onTopSearch = (e) => {
    setSearch(e.target.value);
  };

  const getSearchData = (text)=>{
    if(text && searchingBy){
      setSearchText(text);
      setSearch(`${searchingBy}=${text}`)      
    }else if(!text && searchingBy){
      dispatch(getOrganizations(1, null,setIsloading))
    }
  }

  return (
    <DashboardLayout>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Row gutter={[24, 10]}>
            <Col span={24}>
            
              <SectionHeader
                PaymentModeOptions={type === "Pickup-Requests" || type === "Login-Activity" ? [] : paymentTypes}
                setSearchBy={setSearchBy}
                searchingBy={searchingBy}
                setSearchText={setSearchText}
                searchingText={searchingText}
                searchOptions={initialSearchKeys}
                organizationList={organizationList}
                paymentReports={true}
                exportAction={true}
                heading={type}
                total={totalRecord}
                noBorder={false}
                requiredOrgOptions={type === "Login-Activity" ? true : false}
                setOrgId={setOrgId}
                setSelectMid={setSelectMid}
                setPaymentType={setPaymentType}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setExportReport={setExportReport}
              />

            </Col>
            {
              type === "Pickup-Requests" ? (
                <CourierPayment
                  setTotalRecord={setTotalRecord}
                  midId={midId}
                  totalRecord={totalRecord}
                  searchText={searchingText}
                  searchingBy={searchingBy}
                  orgId={orgId}
                  paymentType={paymentType}
                  startDate={startDate}
                  endDate={endDate}
                  setExportReport={setExportReport}
                  exportReport={exportReport}
                />
              ) : type === "Login-Activity" ? (
                <ExportAuditReportComponent
                  setTotalRecord={setTotalRecord}
                  totalRecord={totalRecord}
                  searchText={searchingText}
                  searchingBy={searchingBy}
                  orgId={orgId ? orgId?.label?.toLowerCase() : orgId}
                  startDate={startDate}
                  endDate={endDate}
                  setExportReport={setExportReport}
                  exportReport={exportReport}
                  isLoginReport={true}
                />
              ) : (
                <OnlinePayment
                  setTotalRecord={setTotalRecord}
                  midId={midId}
                  totalRecord={totalRecord}
                  searchText={searchingText}
                  searchingBy={searchingBy}
                  orgId={orgId}
                  paymentType={paymentType}
                  startDate={startDate}
                  endDate={endDate}
                  setExportReport={setExportReport}
                  exportReport={exportReport}
                />
              )
            }
          </Row>
        </Col>
      </Row>
    </DashboardLayout>
  );
};
